import { MetricsList } from "./MetricsList";

export const IndustryMetrics = ({ metrics, children }) => {
  return (
    <div className="industry_metrics-background">
      <div className="industry_metrics">
        <section className="section-layout rounded">
          <MetricsList metrics={metrics} className="" />
          {children}
        </section>
      </div>
    </div>
  );
};
